import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'
import IdleTimer from 'react-idle-timer'
import * as auth from './services/OnBoarding/auth'
import RemoteAuthRedirect from './components/RemoteAuthRedirect'
import ClinicsPage from './containers/ClinicSetup/ClinicsPage'

import { A_ClearToken } from './actions'

import { REDIRECT_TO_V2_APP } from './api_urls'
import { Fragment, useEffect } from 'react'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const forceLogout = () => {
    localStorage.clear()
    sessionStorage.clear()
    window.location.reload()
  }

  return (
    <Route
      {...rest}
      render={props =>
        auth.isLoggedIn() ? (
          <Fragment>
            <IdleTimer onIdle={forceLogout} timeout={1000 * 60 * 60} />
            <Component {...props} />
          </Fragment>
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  )
}

PrivateRoute.defaultProps = {
  location: {},
}

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object,
}

// Fresh loads are already gated in main.jsx; this only catches client-side
// navigation into a path v1 no longer serves (e.g. PrivateRoute bouncing to
// '/' when a session disappears mid-session). Redirecting from an effect
// rather than from render keeps the route from returning undefined.
const RedirectToV2 = () => {
  useEffect(() => {
    window.location.replace(REDIRECT_TO_V2_APP)
  }, [])

  return null
}

const Routes = () => (<Switch>
      <Route exact path="/remoteAuthRedirect" component={RemoteAuthRedirect} />
      <Route
        path="/clinics/invite/accept"
        render={() => {
          localStorage.clear()
          A_ClearToken()
          return <Redirect to="/" />
        }}
      />
      <PrivateRoute path="/clinics" component={ClinicsPage} />
      <Route component={RedirectToV2} />
    </Switch>)

export default Routes
